import type { EditableSubEntry } from "src/types"

export const newSubEntryTemplate: EditableSubEntry<undefined> = {
  image_id: null,
  note: null,
  subentry_type: undefined,
}
